import React from "react";
import AntdInputNumber, { InputNumberProps } from "antd/lib/input-number";
import { withError } from '@fishx/tracker';
// import { withError, useTracker, TrackEventType, getTrackEventInfo } from '@fishx/tracker';

interface RefInputNumberProps extends InputNumberProps{
  forwardedRef?: any;
}

export const InputNumber: React.FC<RefInputNumberProps> = (props) => {
  // const log = useTracker(InputNumber.displayName);
  const { onClick, onKeyDown, onDoubleClick, onFocus, forwardedRef, ...other } = props;
  // let origValue;
  return(
     <AntdInputNumber { ...other} 
      ref = {forwardedRef}
    //   onClick={e => {
    //   onClick && onClick(e);
    //   log(getTrackEventInfo(e, TrackEventType.CLICK, { origValue }));
    // }}
    // onChange={value => {
    //   onChange && onChange(value);
    //   log(getTrackEventInfo(e.nativeEvent, TrackEventType.KEYDOWN, { origValue }));
    // }}
    // onKeyDown = {e => {
    //   onKeyDown && onKeyDown(e);
    //   getTrackEventInfo(e, TrackEventType.KEYDOWN, { origValue: origValue });
    // }}
    // onFocus={e => {
    //   onFocus && onFocus(e);
    //   log(getTrackEventInfo(e, TrackEventType.FOCUS));
    //   origValue = e.target && e.target.value;
    // }}
     />
  )
};

InputNumber.displayName = 'InputNumber';
export default withError(InputNumber, {forwardRef: true});


// WEBPACK FOOTER //
// ./src/components/input-number/index.tsx